import { CellCustomType } from "@lhd/components/CloneApp/pages/SheetApp/type";

export const MIN_ROW_HEIGHT = 35;

export const ROW_HEIGHT_REMEASURE_MS = 100;

export const calcRowHeight = (
  cells: CellCustomType[],
  container: HTMLElement | null,
): number => {
  if (!container) return MIN_ROW_HEIGHT;
  let max = MIN_ROW_HEIGHT;
  cells.forEach((cell) => {
    if (cell.maxHeight) {
      max = Math.max(max, cell.maxHeight);
      return;
    }
    const el = container.querySelector(
      `.rg-cell[data-cell-rowidx="${cell.rowIndex}"][data-cell-colidx="${cell.cellIndex}"]`,
    );

    const scrollHeight = (el?.firstChild as HTMLElement)?.scrollHeight;
    if (scrollHeight) {
      max = Math.max(max, scrollHeight);
    }
  });

  return max;
};
